// Sunsari Restaurant Table Layout Data
// Based on actual floor plan and real restaurant photos

export const restaurantTables = {
  // Window Tables by Door (Premium street view) - 4+4 seats
  windowTables: [
    { id: 'W1', name: 'Window Table 1', capacity: 4, type: 'window', x: 10, y: 25, features: ['Street View', 'Natural Light', 'By Door'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/obvc9vi5_Windows%20table%20next%20to%20door%204%2B4.jpg' },
    { id: 'W2', name: 'Window Table 2', capacity: 4, type: 'window', x: 10, y: 45, features: ['Street View', 'Natural Light', 'By Door'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/obvc9vi5_Windows%20table%20next%20to%20door%204%2B4.jpg' }
  ],
  
  // Cabinet 1 Area (Mountain artwork wall) - Total 16 seats (2+4+2+2+2+4)
  cabinet1Area: [
    { id: 'CAB1-T1', name: 'Cabinet 1 - Table 1', capacity: 2, type: 'cabinet', x: 85, y: 15, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' },
    { id: 'CAB1-T2', name: 'Cabinet 1 - Table 2', capacity: 4, type: 'cabinet', x: 85, y: 28, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' },
    { id: 'CAB1-T3', name: 'Cabinet 1 - Table 3', capacity: 2, type: 'cabinet', x: 85, y: 41, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' },
    { id: 'CAB1-T4', name: 'Cabinet 1 - Table 4', capacity: 2, type: 'cabinet', x: 85, y: 52, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' },
    { id: 'CAB1-T5', name: 'Cabinet 1 - Table 5', capacity: 2, type: 'cabinet', x: 85, y: 63, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' },
    { id: 'CAB1-T6', name: 'Cabinet 1 - Table 6', capacity: 4, type: 'cabinet', x: 85, y: 76, features: ['Mountain Art Wall', 'Quiet Corner'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l4ctlh45_cabinet%201%20full%20photo.jpg' }
  ],
  
  // Cabinet 1 Window Table - 4+2 seats (6 total)
  cabinet1WindowTable: [
    { id: 'CAB1-WIN1', name: 'Cabinet 1 Window - Section 1', capacity: 4, type: 'cabinet', x: 78, y: 25, features: ['Window View', 'Mountain Art Wall', 'Natural Light'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/k34od116_cabinet%201%20window%20table.jpg' },
    { id: 'CAB1-WIN2', name: 'Cabinet 1 Window - Section 2', capacity: 2, type: 'cabinet', x: 78, y: 40, features: ['Window View', 'Mountain Art Wall', 'Natural Light'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/k34od116_cabinet%201%20window%20table.jpg' }
  ],
  
  // Corner Sofa/Booth Area - 6+4 seats (10 total)
  cornerSofaBooth: [
    { id: 'SOFA1', name: 'Corner Sofa Section 1', capacity: 6, type: 'booth', x: 20, y: 30, features: ['Comfortable Leather Booth', 'Corner Location', 'Next to Bar'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/fp25o0oh_corner%20sofa%20table%206%2B4.jpg' },
    { id: 'SOFA2', name: 'Corner Sofa Section 2', capacity: 4, type: 'booth', x: 20, y: 55, features: ['Comfortable Leather Booth', 'Corner Location', 'Next to Bar'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/fp25o0oh_corner%20sofa%20table%206%2B4.jpg' }
  ],
  
  // Center Group Table - 12 seats
  centerGroupTable: [
    { id: 'CENTER12', name: 'Center Group Table (12 Seats)', capacity: 12, type: 'group', x: 50, y: 50, features: ['Large Group', 'Traditional Carved Chairs', 'Center Location', 'Perfect for Celebrations'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/lkwpq49f_group%20table%20of%2012.jpg' }
  ],
  
  // Decorative Hut (Special traditional seating) - 4+4 seats (8 total)
  decorativeHut: [
    { id: 'HUT1', name: 'Decorative Hut Table 1', capacity: 4, type: 'special', x: 65, y: 70, features: ['Traditional Carved Wood Hut', 'Private Setting', 'VIP Experience', 'Unique Ambiance'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l3hnz07u_decorative%20hut%20tables%202%2B2.jpg' },
    { id: 'HUT2', name: 'Decorative Hut Table 2', capacity: 4, type: 'special', x: 75, y: 70, features: ['Traditional Carved Wood Hut', 'Private Setting', 'VIP Experience', 'Unique Ambiance'], photo: 'https://customer-assets.emergentagent.com/job_8f790146-acd4-4a9a-93d7-80916b412d08/artifacts/l3hnz07u_decorative%20hut%20tables%202%2B2.jpg' }
  ]
};

// Get all tables as flat array
export const getAllTables = () => {
  return [
    ...restaurantTables.windowTables,
    ...restaurantTables.cabinet1Area,
    ...restaurantTables.cabinet1WindowTable,
    ...restaurantTables.cornerSofaBooth,
    ...restaurantTables.centerGroupTable,
    ...restaurantTables.decorativeHut
  ];
};

// Get table by ID
export const getTableById = (tableId) => {
  const allTables = getAllTables();
  return allTables.find(table => table.id === tableId);
};

// Calculate total capacity
export const getTotalCapacity = () => {
  const allTables = getAllTables();
  return allTables.reduce((sum, table) => sum + table.capacity, 0);
};

// Get tables by capacity requirement
export const getTablesByCapacity = (guestCount) => {
  const allTables = getAllTables();
  return allTables.filter(table => table.capacity >= guestCount);
};

// Get premium tables (window, hut, etc.)
export const getPremiumTables = () => {
  return [
    ...restaurantTables.windowTables,
    ...restaurantTables.decorativeHut
  ];
};

// Table type colors for UI
export const tableTypeColors = {
  window: { bg: 'bg-blue-500/20', border: 'border-blue-400', text: 'text-blue-300' },
  cabinet: { bg: 'bg-green-500/20', border: 'border-green-400', text: 'text-green-300' },
  booth: { bg: 'bg-purple-500/20', border: 'border-purple-400', text: 'text-purple-300' },
  group: { bg: 'bg-amber-500/20', border: 'border-amber-400', text: 'text-amber-300' },
  special: { bg: 'bg-pink-500/20', border: 'border-pink-400', text: 'text-pink-300' },
  regular: { bg: 'bg-gray-500/20', border: 'border-gray-400', text: 'text-gray-300' }
};
